import {
  getNeededPurple,
  getNeededRowBackground,
} from '../NavNeededIndicator/NavNeededIndicator.styles';

// A compact purple count pill echoing the field-level "Needed" signal (DEV-4496),
// surfaced on a modal OPENER (e.g. a borrower edit-modal table row) to show how
// many checklist-linked fields inside the modal still need attention WITHOUT
// opening it (DEV-4386). Theme-aware in lockstep with the inner-nav row: a light
// purple tint + deep purple text in light mode, and a deep tint + light purple
// text in dark mode, so the pill stays legible on either backdrop.
export const badgeContainerStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '18px',
  height: '18px',
  padding: '0 6px',
  borderRadius: '9px',
  backgroundColor: ({ palette }) => getNeededRowBackground(palette),
  flexShrink: 0,
};

export const badgeLabelStyles = {
  color: ({ palette }) => getNeededPurple(palette),
  lineHeight: 1,
};
